import { installedIds, installedItems } from "../../../install/installed.ts";
import type { PostgresIntegration } from "./types.ts";

export const eligibleSessionAuditItems = (config: PostgresIntegration) => {
  const existingAccessManagementItems = installedItems("iam-write", config);
  const existingSessionAuditIds = installedIds("session-audit", config);

  return Object.entries(existingAccessManagementItems).filter(
    ([id]) => !(id in existingSessionAuditIds)
  );
};
